export const VoucherTypes = {
    types: {
        FA: 'FA',
        FB: 'FB',
        ETicket: 'ETicket',
        EFactura: 'EFactura',
        CreditNoteA: 'CreditNoteA',
        CreditNoteB: 'CreditNoteB',
        CreditNoteETicket: 'CreditNoteETicket',
        DebitNoteA: 'DebitNoteA',
        DebitNoteB: 'DebitNoteB',
        DebitNoteETicket: 'DebitNoteETicket',
        CreditNoteEFactura: 'CreditNoteEFactura'

    },
    labels: {
        FA: 'Factura A',
        FB: 'Factura B',
        ETicket: 'ETicket',
        EFactura: 'EFactura',
        CreditNoteA: 'Nota de Credito A',
        CreditNoteB: 'Nota de Credito B',
        CreditNoteETicket: 'Nota de Credito',
        DebitNoteA: 'Nota de Debito A',
        DebitNoteB: 'Nota de Debito B',
        DebitNoteETicket: 'Nota de Debito',
        CreditNoteEFactura: 'Nota de Credito'
    }
}